import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { UserModel } from '@/core/models/user.model';
import { ExtendedAuthenticationService } from '../../components/authentication/services/extended-authentication.service';
import { GetTokenResponse } from '../../components/authentication/repositories/abstractions/token.repository';
import { IdToken } from '@/core/models/id-token.model';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserResolver implements Resolve<UserModel> {
  constructor(protected authenticationService: ExtendedAuthenticationService) {
    //
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserModel> {
    var response: GetTokenResponse<string, IdToken> = this.authenticationService.getIdToken();

    if(this.authenticationService.CurrentUser)
    {
      return of(this.authenticationService.CurrentUser);
    }
    
    return EMPTY;
  }
}
